"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transform = transform;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _text = _interopRequireDefault(require("@ux/text"));
const _excluded = ["title", "content", "children", "fadeTime", "lifetime", "icon", "emphasis", "id"];
/* eslint-disable complexity, max-statements, no-console */
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Generates an id
 * @returns {Number} - An incremented number
 */
let i = 0;
function generateNextId() {
  return i++;
}

/**
 * Converts the addGrowlMessage configuration object into props for <Dialog/>
 *
 * @param {Object} config - Configuration object
 * @param {String|Node} title - Title of the message
 * @param {Node} content - Alias for children
 * @param {Node} children - Content for the message
 * @param {Number} fadeTime - Alias for lifetime
 * @param {Number} lifetime - The amount of time to persist the message
 * @param {String} icon - Alias for emphasis
 * @param {String} emphasis - The status of the message, one of the feedback types
 * @param {String} id - A unique id for the message
 * @returns {Object} - A converted props object for <Dialog/>
 */
function transform(config) {
  const {
      title,
      content,
      children,
      fadeTime,
      lifetime,
      icon,
      emphasis,
      id
    } = config,
    rest = (0, _objectWithoutProperties2.default)(config, _excluded);
  warn(config);
  const translation = icon === 'none' ? 'info' : icon || emphasis;
  return _objectSpread({
    title: typeof title === 'string' ? /*#__PURE__*/_react.default.createElement(_text.default.h2, {
      text: title,
      as: "title"
    }) : title,
    children: content || children,
    lifetime: fadeTime || lifetime,
    id: id || `ux-growl-${generateNextId()}`,
    emphasis: translation
  }, rest);
}
const warnings = new Set();

/**
 * Warns when the shim is used
 *
 * @param {Object} props - Configuration object
 * @param {Node} content - Alias for children
 * @param {Number} fadeTime - Alias for lifetime
 * @param {String} icon - Alias for emphasis
 * @param {String} id - A unique id for the message
 */
function warn(props) {
  const {
    content,
    fadeTime,
    icon,
    id
  } = props;
  if (content) {
    const warning = 'Prop `content` for Growl.addGrowlMessage will be removed in v2201, please replace with `children`';
    !warnings.has(warning) && warnings.add(warning) && console.warn(warning);
  }
  if (fadeTime) {
    const warning = 'Prop `fadeTime` for Growl.addGrowlMessage will be removed in v2201, please replace with `lifetime`';
    !warnings.has(warning) && warnings.add(warning) && console.warn(warning);
  }
  if (icon) {
    const warning = 'Prop `icon` for Growl.addGrowlMessage will be removed in v2201, please replace with `emphasis`';
    !warnings.has(warning) && warnings.add(warning) && console.warn(warning);
  }
  if (icon === 'none') {
    const warning = '`icon=none` for Growl.addGrowlMessage now maps to emphasis=info, icons are required for all Growl messages';
    !warnings.has(warning) && warnings.add(warning) && console.warn(warning);
  }
  if (!id) {
    const warning = 'Prop `id` for Growl.addGrowlMessage is required for 2200';
    !warnings.has(warning) && warnings.add(warning) && console.warn(warning);
  }
}